import React from "react"
import Select from "react-select"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import selectMenuStyles from "src/pages/dynamic_forms/Utils/SelectMenuStyles"
import { OverlayTrigger } from "react-bootstrap"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./MultiSelectField.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function MultiSelectField(props: Props) {

    // console.log("df_FieldMultiSelectField props", props)

    const field = props.field
    const options = field.CustomValues
    //@ts-ignore
    const value = !props.formManagerField ? ((field.Value && typeof (field.Value === "string")) ? field.Value.split(",") : field.Value) : null
    const name = field.Name || "Multi Select"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"
    const menuPosition = fieldType === "Field" ? "fixed" : "absolute"

    const filterNulls = (items: Array<string | null>) => {
        let filtered: Array<string> = []
        for (let i = 0; i < items.length; i++) {
            if (typeof (items[i] === "string")) {
                //@ts-ignore
                filtered.push(items[i])
            }
        }
        return filtered
    }


    return (
        <div className={`DynamicForm${fieldType} DynamicFormMultiSelect${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                <Select
                    isMulti={true}
                    //@ts-ignore
                    value={value ? value.map((item: string) => ({ value: item, label: item })) : []}
                    placeholder={props.field.Label}
                    options={filterNulls(options || []).map(item => ({ value: item, label: item }))}
                    //@ts-ignore
                    onChange={(items: Array<{ value: string, label: string }> | null) => {
                        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])
                        setTimeout(() => {
                            let temp = []
                            if (items && items.length > 0) {
                                for (let i = 0; i < items.length; i++) {
                                    temp.push(items[i].value)
                                }
                                props.handleChange({ target: { value: temp.join(",") } })
                            } else {
                                props.handleChange({ target: { value: null } })
                            }
                        }, 100);
                    }}
                    menuPosition={menuPosition}
                    styles={selectMenuStyles}
                />
            </div>
        </div>
    )
}

export default MultiSelectField